import {useCustomer} from '../../Customer';


/**
 * @return {object} Billing data of the current user's publication context
 */
function useBillingData() {

    const customer = useCustomer();

    return customer.billingData;
}


export default useBillingData;
